(function ($) {
    iFrameResize();
}(jQuery));